import { render, staticRenderFns } from "./FaceHands.vue?vue&type=template&id=2a6fd344&scoped=true"
import script from "./FaceHands.vue?vue&type=script&lang=js"
export * from "./FaceHands.vue?vue&type=script&lang=js"
import style0 from "./FaceHands.vue?vue&type=style&index=0&id=2a6fd344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6fd344",
  null
  
)

export default component.exports